import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "_hooks";
import { useOnBoardingGs1 } from "partner/_hooks";
import { InputControl } from "components/organism";
import { Button } from "components/atoms";
import { forgotSchema } from "_config/formSchemas";

const prefix = "vv-forgot";

const Forgot = () => {
  const { forgot, forgotData, forgotIsLoading, forgotReset } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(forgotSchema)
  });
  const navigate = useNavigate();
  const { lookAndFeel } = useOnBoardingGs1();
  const { partner } = useParams();

  const onSubmit = ({ email }) => forgot(
    { account: email },
    { feedback: { error: true }}
  );

  const redirect = useCallback(() => {
    setTimeout(() => {
      navigate(`/partner/${partner}/login`);
    }, 1000);
  }, [navigate, partner]);

  useEffect(() => {
    return () => {
      forgotReset();
    };
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (forgotData) redirect();
  }, [forgotData, redirect])
  
  return (
    <div className={`${prefix} h-full flex flex-col justify-center text-center`}>
      <div className="flex flex-wrap flex-col gap-5">
        <p className="text-center text-2xl font-bold mx-auto">Recuperar contraseña</p>
        <p className="text-center text-md">Te enviaremos un correo con instrucciones</p>

        <form onSubmit={handleSubmit(onSubmit)}>
          <InputControl 
            className="mb-10"
            errors={errors?.email}
            inputProps={{
              autoComplete: "off",
              placeholder: "Ej. nombre@tuempresa.com",
              ...register("email")
            }}
            label="Correo electrónico"
            orientation="vertical"
          />

          <Button
            disabled={forgotData || forgotIsLoading}
            className="rounded-lg"
            style={{
              backgroundColor: lookAndFeel?.primary?.solid,
              color: lookAndFeel?.primary?.text
            }}
            fullwidth
            height={10}
            pulse
          >Continuar</Button>

        </form>

        <span className="text-gray-800 w-full text-center">
          ¿Ya tienes una cuenta? <Link to={`/partner/${partner}/login`} className="underline">Iniciar sesión</Link>
        </span>
      </div>
    </div>
  );
};

export default Forgot;
